<template>
  <div v-if="!isLoading">
    <!-- MOSTRAR DELETE -->
    <v-dialog
      v-model="isDialogVisibleDelete"
      scrollable
      max-width="400px"
    >
      <v-card max-height="400px">
        <v-card-title>{{ `${$t('btn.cancele')} ${item.code}` }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>{{ $t('msg.deleteBookingItem', { item: item.code }) }}</v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            outlined
            @click="isDialogVisibleDelete = !isDialogVisibleDelete"
          >
            {{ $t('btn.close') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            :loading="loading"
            @click="confirmDelete()"
          >
            {{ $t('btn.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-uppercase">
              {{ $t('lbl.code') }}
            </th>
            <th class="text-uppercase">
              {{ $t('lbl.client') }}
            </th>
            <th class="text-uppercase">
              {{ $t('lbl.product') }}
            </th>
            <th class="text-uppercase">
              {{ $t('lbl.service') }}
            </th>
            <th class="text-uppercase">
              {{ $t('lbl.venta') }}
            </th>
            <th class="text-uppercase">
              {{ $t('lbl.vendedor') }}
            </th>
            <!--<th class="text-uppercase">
          {{ $t('lbl.compra') }}
        </th>-->
            <th class="text-uppercase">
              {{ $t('lbl.state') }}
            </th>
            <th
              v-if="
                permisos.includes('reservas:list') ||
                  permisos.includes('reservas:edit') ||
                  permisos.includes('reservas:destroy') ||
                  permisos.includes('*')
              "
              class="text-uppercase"
            >
              {{ $t('lbl.actions') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(reserva, index) in reservas"
            :key="index"
          >
            <td width="15%">
              <span
                class="d-inline-block text-caption"
                :style="`color: ${$vuetify.theme.themes.light.primary}`"
              >
                {{ reserva.code }}
              </span>
            </td>
            <td>
              <span v-if="reserva.cliente">
                {{ reserva.cliente.name }}
                {{ reserva.cliente.apellidos }}<br />
                <a
                  v-if="reserva.cliente.email"
                  :href="`mailito:${reserva.cliente.email}`"
                >
                  {{ reserva.cliente.email }}
                </a>
                <a
                  v-else-if="reserva.cliente.email_reservas"
                  :href="`mailito:${reserva.cliente.email_reservas}`"
                >
                  {{ reserva.cliente.email_reservas }}
                </a>
                <span v-if="reserva.cliente.telefono"> <br />{{ reserva.cliente.telefono }} </span>
              </span>
              <!--<span
                v-if="reserva.cliente.length > 0"
                class="d-inline-block text-caption"
              >
                <span v-if="reserva.cliente[0].email">
                  {{ reserva.cliente[0].email }}
                </span>
              </span> -->
            </td>
            <td>
              <fragment v-if="reserva.entities">
                <span v-if="reserva.entities.length > 1">
                  <v-tooltip
                    top
                    color="primary"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>{{ icons.mdiPackage }}</v-icon> {{ $t('lbl.paquet') }}
                      </span>
                    </template>
                    <span>
                      <span
                        v-for="(entity, ind) in reserva.entities"
                        :key="ind"
                      >
                        <fragment v-if="entity === 'flights'">
                          <v-icon style="color: #FFF;">{{ icons.mdiAirplaneTakeoff }}</v-icon> {{ $t('lbl.flight')
                          }}<br />
                        </fragment>
                        <fragment v-if="entity === 'cars'">
                          <v-icon style="color: #FFF;">{{ icons.mdiCar }}</v-icon> {{ $t('lbl.car') }} <br />
                        </fragment>
                        <fragment v-if="entity === 'hotels'">
                          <v-icon style="color: #FFF;">{{ icons.mdiBed }}</v-icon> {{ $t('lbl.hotel') }} <br />
                        </fragment>
                      </span>
                    </span>
                  </v-tooltip>
                </span>
                <span v-else>
                  <fragment v-if="reserva.entities.includes('flights')">
                    <v-icon>{{ icons.mdiAirplaneTakeoff }}</v-icon> {{ $t('lbl.flight') }}
                  </fragment>
                  <fragment v-else-if="reserva.entities.includes('cars')">
                    <v-icon>{{ icons.mdiCar }}</v-icon> {{ $t('lbl.car') }}
                  </fragment>
                  <fragment v-else-if="entity === 'hotels'">
                    <v-icon>{{ icons.mdiBed }}</v-icon> {{ $t('lbl.hotel') }}
                  </fragment>
                </span>
              </fragment>
            </td>
            <td>
              <span v-if="reserva.date_servicio.length > 0">
                {{ reserva.date_servicio[0] | moment('D/MM/Y') }}
              </span>
            </td>
            <td>
              <span :style="`color: ${$vuetify.theme.themes.light.primary}`">
                <!--{{ reserva.price_total | currency }} </span><br />-->
                {{ reserva.pricePayOnline | currency }} </span><br />
              {{ reserva.price_names.text }}
            </td>
            <td width="20%">
              <span class="d-inline-block text-caption">{{ reserva.afiliado.name }}</span><br />
              {{
                reserva.afiliado.company !== null
                  ? reserva.afiliado.company
                  : reserva.afiliado.nivel === 0
                    ? 'Propietario'
                    : ''
              }}
            </td>
            <!--<td>{{ reserva.date_compra | moment('D/MM/Y') }}</td>-->
            <td>
              <v-chip
                :color="reserva.color_state"
                text-color="white"
              >
                {{ reserva.state_reserva.name }}
              </v-chip>
            </td>
            <td
              v-if="permisos.includes('reservas:edit') || permisos.includes('reservas:list') || permisos.includes('*')"
              width="10%"
            >
              <v-menu
                v-if="
                  permisos.includes('reservas:edit') || permisos.includes('reservas:list') || permisos.includes('*')
                "
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-if="permisos.includes('reservas:list')"
                    link
                    @click="showItem(reserva)"
                  >
                    <v-list-item-title>
                      <v-btn icon>
                        <v-icon>{{ icons.mdiEye }}</v-icon>
                      </v-btn>
                      <span>{{ $t('btn.see') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      (permisos.includes('reservas:edit') || permisos.includes('*')) &&
                        !reserva.cancelada &&
                        (reserva.afiliado.nivel === user.nivel || user.nivel <= 0)
                    "
                    link
                    @click="editItem(reserva)"
                  >
                    <v-list-item-title>
                      <v-btn icon>
                        <v-icon>{{ icons.mdiSquareEditOutline }}</v-icon>
                      </v-btn>
                      <span>{{ $t('btn.edit') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  mdiMagnify,
  mdiDeleteOutline,
  mdiSquareEditOutline,
  mdiPlus,
  mdiArrowLeft,
  mdiUpdate,
  mdiFormatListText,
  mdiAirplaneTakeoff,
  mdiCar,
  mdiBed,
  mdiClose,
  mdiEye,
  mdiEraserVariant,
  mdiPackage,
  mdiDotsVertical,
} from '@mdi/js'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    user: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    reservas: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    states: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop, vue/prop-name-casing
    tipos_product: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    names: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    codes: {
      type: Array,
    },
  },
  data() {
    return {
      isLoading: true,
      icons: {
        mdiMagnify,
        mdiDeleteOutline,
        mdiSquareEditOutline,
        mdiPlus,
        mdiArrowLeft,
        mdiUpdate,
        mdiFormatListText,
        mdiAirplaneTakeoff,
        mdiCar,
        mdiBed,
        mdiClose,
        mdiEye,
        mdiEraserVariant,
        mdiPackage,
        mdiDotsVertical,
      },
      isDialogVisibleDelete: false,
      item: {},
      itemId: null,
      loading: false,
      permisos: sessionStorage.getItem('permisos_auth'),
    }
  },
  computed: {
    ...mapState({
      posCotizador: state => state.app.posCotizador,
    }),
  },
  created() {
    this.isLoading = false
  },
  methods: {
    ...mapMutations(['setPosCotizador']),
    showItem(iten) {
      sessionStorage.setItem('reservations-id', iten.id)
      this.$router.push({ name: 'reservations-show' })
    },
    editItem(iten) {
      sessionStorage.setItem('reservations-id', iten.id)
      this.$router.push({ name: 'reservations-update' })
    },

    deleteItem(iten) {
      this.isDialogVisibleDelete = true
      this.item = iten
      this.itemId = iten.id
    },
    confirmDelete() {
      this.axios
        .delete(`reservations/${this.itemId}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            this.load()
          }
        })
        .finally(() => this.reseat())
    },
    reseat() {
      this.isDialogVisible = false
      this.isDialogVisibleDelete = false
      this.item = {}
      this.itemId = null
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}
</style>
